import { generatePath } from "react-router-dom";

/**
 * Creates a typed path builder function from a route template string.
 * Params type is inferred from the template's `:param` segments via
 * React Router's template-literal type inference — no manual typing needed.
 *
 * @example
 * const toDocument = RoutePath("/account/document/:id");
 * toDocument({ id: "abc" }); // "/account/document/abc"
 */
export const RoutePath =
  <Path extends string>(template: Path) =>
  (params: Parameters<typeof generatePath<Path>>[1]) =>
    generatePath(template, params);
